module.exports = __webpack_public_path__ + "static/media/5.6ce3e9ec.png";